import { Globe, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { detectLang, setLang, supportedLangs, bundles } from "@/i18n/detect";
import type { Lang } from "@/i18n/types";

const LanguageSwitcher = ({ variant = "icon" }: { variant?: "icon" | "full" }) => {
  const current = detectLang();
  const names = bundles[current].ui.languageNames;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size={variant === "icon" ? "icon" : "sm"}
          aria-label={bundles[current].ui.nav.language}
          className={variant === "icon" ? "min-h-11 min-w-11" : "gap-2"}
        >
          <Globe className="h-4 w-4" />
          {variant === "full" && <span>{names[current]}</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {supportedLangs.map((l: Lang) => (
          <DropdownMenuItem
            key={l}
            onClick={() => l !== current && setLang(l)}
            className="flex items-center justify-between"
          >
            <span>{names[l]}</span>
            {l === current && <Check className="h-4 w-4 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
